module.exports = __webpack_public_path__ + "static/img/lirucheng.25fadab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/lirucheng.png
// module id = 4M2p
// module chunks = 0